import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { Presignup } from '../models/presignup.interface.js';
import Swal from 'sweetalert2';
import { handleResponseError } from '../../utils/errorHandlers.js';
import { environment } from './../../../environments/environment.js';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) { }

  login(data: any): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/login`, data, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  submitSignup(data: Presignup): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/user/downsizer`, data, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  sendOTP(data: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http
      .post<any>(`${environment.apiUrl}/auth/send-otp`, data, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  verifyOTP(data: any, userId: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http
      .post<any>(`${environment.apiUrl}/auth/verify-otp/${userId}`, data, {
        headers: headers,
      })
      .pipe(catchError(handleResponseError));
  }
  refreshToken(token: any): Observable<any> {
    return this.http
      .post<any>(
        `${environment.apiUrl}/auth/refresh`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .pipe(catchError(handleResponseError));
  }

  forgotPassword(email: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/forgot-password`, { email }, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  setPassword(password: string, confirmPassword: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/set-password`, { password, confirmPassword }, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  resetPassword(password: string, confirmPassword: string, token: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/reset-password`, { password, confirmPassword, token }, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  showAlert(alertText: any, alertIcon: any) {
    Swal.fire({
      position: 'top-end',
      icon: alertIcon,
      text: alertText,
      showConfirmButton: false,
      timer: 1500,
      toast: true,
    });
  }

  sendLoginOtp(email: string, type: 'email' | 'sms', role: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/send-login-otp`, { email, type, role }, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

  verifyLoginOtp(email: string, code: string): Observable<any> {
    return this.http
      .post<any>(`${environment.apiUrl}/auth/verify-login-otp`, { email, code }, {
        headers: this.headers,
      })
      .pipe(catchError(handleResponseError));
  }

}
